import { API } from '../constants/Constants';
import Instance from './interceptor';
import Toast from '../components/pages/utils/Toast';
import { DOCUMENT_TOAST } from '../constants/toastConstant';

export const SearchedData = async (data) => {
  try {
    return await Instance.get(`${API.SEARCHED_DATA}`, {
      params: { searchData: data },
    });
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({ message: `${error.response.data.message}`, variant: 'success' });
    } else if (error.message) {
      Toast({ message: `${error.message}`, variant: 'error' });
    } else {
      Toast({
        message: 'An error occurred while fetching data.',
        variant: 'error',
      });
    }
    return null;
  }
};

export const FilterSortApi = async (data, documentStage, tagId) => {
  const requestedData = {
    tags: tagId,
    documentStage,
    searchData: data,
    sortField: '',
    sortOrder: '',
  };
  try {
    const response = await Instance.post(`${API.SORT_ROW_DATA}`, requestedData);
    if (response?.data?.documents.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response;
    }
    return response;
  } catch (error) {
    if (error.message) {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

export const fetchNotifications = async (data, page, limit) => {
  try {
    let url = API.ALL_NOTIFICATION;

    // Check if page and limit are present
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    }

    let payload = null;
    if (data) {
      payload = {
        searchData: data?.searchData,
        notificationStatus: data?.notificationStatus,
        uploadStatus: data?.uploadStatus,
      };
    }
    const response = await Instance.post(url, payload);
    if (response) {
      const { notifications, remainingCount, unreadCount, readCount } =
        response?.data || {};
      return { notifications, remainingCount, unreadCount, readCount };
    }
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message:
          'Unable to fetch notifications. Please check your connection and try again.',
        variant: 'error',
      });
    }
    return [];
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await Instance.patch(
      `${API.READ_NOTIFICATION}/${notificationId}`,
      {
        status: 'read',
      },
    );
    if (response) {
      return response;
    }
  } catch (error) {
    if (error.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};

export const markAllAsReadNotifications = async () => {
  try {
    const response = await Instance.patch(`${API.READ_ALL_NOTIFICATIONS}`, {
      status: 'read',
    });
    if (response) {
      return response;
    }
  } catch (error) {
    if (error.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};

export const markAsReadForSelectedAsNotifications = async (documentId) => {
  try {
    const requestedTag = {
      documents: documentId,
    };
    const response = await Instance.patch(
      `${API.READ_ALL_NOTIFICATIONS}`,
      requestedTag,
      {
        status: 'read',
      },
    );
    if (response) {
      return response;
    }
  } catch (error) {
    if (error.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};

export const getNotificationGird = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
) => {
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.document_status.map((s) => s.status);
  const readValue =
    dropDownValue &&
    Object.keys(dropDownValue).length > 0 &&
    dropDownValue.notification_status.map((t) => t.label);
  try {
    const data = {
      stage: stageValue,
      notificationStatus: readValue,
      searchData: inputValue,
      filterModel,
      sortOrder: sorting[0]?.sort,
      sortField: sorting[0]?.colId,
    };
    const response = await Instance.post(`${API.ALL_NOTIFICATION}`, data);
    if (response?.data?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data;
    }
    return response?.data;
  } catch (error) {
    if (error?.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message:
          'Unable to fetch notifications. Please check your connection and try again.',
        variant: 'error',
      });
    }
    return [];
  }
};

export const deleteNotification = async (id) => {
  try {
    const response = await Instance.delete(`${API.DELETE_NOTIFICATION}/${id}`);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    if (error.response) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({
        message: `${error?.message}`,
        variant: 'error',
      });
    }
  }
};
